// ─── Paleta de colores de carpeta ────────────────────────────────────────────
// Las claves son las que persiste el backend (helpdesk_folders.color). Clases
// COMPLETAS y literales a propósito: Tailwind no compila templates dinámicos
// (`bg-status-${color}` no genera nada), así que cada combinación tiene que
// existir como string entero en el fuente.
//
// El color NUNCA es la única señal de la carpeta: siempre va acompañado del
// nombre (rail, chips) — el dot es refuerzo visual, no información exclusiva.
export const FOLDER_COLOR_STYLES = {
  success: { dot: "bg-status-success", chip: "bg-status-success-soft text-status-success" },
  error:   { dot: "bg-status-error",   chip: "bg-status-error-soft text-status-error" },
  warning: { dot: "bg-status-warning", chip: "bg-status-warning-soft text-status-warning" },
  info:    { dot: "bg-status-info",    chip: "bg-status-info-soft text-status-info" },
  neutral: { dot: "bg-status-neutral", chip: "bg-status-neutral-soft text-status-neutral" },
};

export const DEFAULT_FOLDER_COLOR = "neutral";

// Orden estable para el selector de color del rail.
export const FOLDER_COLOR_KEYS = ["neutral", "info", "success", "warning", "error"];

// Nombres legibles para aria-label de los botones de color (el dot solo no
// le dice nada al lector de pantalla).
export const FOLDER_COLOR_LABELS = {
  success: "Verde",
  error: "Rojo",
  warning: "Ámbar",
  info: "Azul",
  neutral: "Gris",
};
